import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { Person } from 'src/app/lem/models/person/person';
import { PersonType } from 'src/app/lem/models/person/person-type';
import {PaginatedResponse} from '../../../models/common/paginated-response';
import { Pagable } from "src/app/lem/models/common/pagable";

@Injectable({
  providedIn: 'root'
})
export class PersonService {

  personPath = ServicePathsSettings.URL_PERSON ;
  typesPath = this.personPath + ServicePathsSettings.URL_TYPES;


  // personPath = "http://localhost:8080/persons" ;
  // typesPath = this.personPath  + ServicePathsSettings.URL_PERSONA_TYPES;

  private refreshRequired$ = new Subject<any>();

  constructor(
    private http: HttpClient,
  ) {
  }

  get RefreshRequired$() {
    return this.refreshRequired$.asObservable();
  }


  addPerson(person: Person): Observable<Person> {
    return this.http.post<Person>(this.personPath, person).pipe(tap({ complete: () => (this.refreshRequired$.next(null)) }));
  }

  getAllPerson(): Observable<PaginatedResponse<Person>> {
    return this.http.get<PaginatedResponse<Person>>(this.personPath);;
  }

  deletePerson(person: Person): Observable<void> {
    return this.http.delete<void>(this.personPath + '/' + person.id)
      .pipe(
        tap(() => this.refreshRequired$.next(null))
      );
  }

  editPerson(person: Person): Observable<Person> {
    console.log(person);
    return this.http.put<Person>(this.personPath + '/' + person.id, person)
      .pipe(
        tap(() => this.refreshRequired$.next(null))
      );
  }

  searchPerson(personParamsObj): Observable<PaginatedResponse<Person>> {
    const paramsPerson = new HttpParams({ fromObject: personParamsObj });
    return this.http.get<PaginatedResponse<Person>>(this.personPath,{params:paramsPerson});
  }

  searchPersonPaginated(personParamsObj , pagable : Pagable) : Observable<PaginatedResponse<Person>>{
    let paramsPerson = new HttpParams({ fromObject: personParamsObj})
    if(pagable){
      paramsPerson = paramsPerson.append('page', ''+pagable.page);
      paramsPerson = paramsPerson.append('size', ''+pagable.size);
    }
    return this.http.get<PaginatedResponse<Person>>(this.personPath, { params: paramsPerson });
  }

  findById(id: string): Observable<Person> {
    return this.http.get<Person>(this.personPath + '/' + id);
  }

  getAllType(): Observable<PersonType[]> {
    return this.http.get<PersonType[]>(this.typesPath);
  }


  personTypeSwitcher(personFormData: Person): Person {
    switch (personFormData.type) {
      case 'LEGAL_ENTITY' : {
        const { email, firstName, lastName, ...newPerson } = personFormData;
        return newPerson;
      }
      case 'PHYSICAL_ENTITY' : {
        const { name, vatNumber, ...newPerson } = personFormData;
        return newPerson;
      }
    }
  }
}
